import { PortableText } from "@portabletext/react"
import { Link } from "gatsby"
import React from "react"
import "./contentSection.scss"

function ContentSection({ classname, data }) {
  const srelizerComponent = {
    marks: {
      link: ({ children, value }) => {
        const { blank, href } = value
        return blank ? (
          <a
            title={href}
            href={href}
            target="_blank"
            rel="noopener"
            // style={{ textDecoration: "underline" }}
          >
            {children}
          </a>
        ) : (
          <a href={href} title={href}>
            {children}
          </a>
        )
      },
      color: ({ children, value }) => {
        return <span style={{ color: value.color }}>{children}</span>
      },
    },
  }

  return (
    <div className={`content-section ${classname}`} id={classname}>
      <div className="content-section-header">
        {/* <h2>What We Offer</h2> */}
        <PortableText value={data?._rawTitle} components={srelizerComponent} />
      </div>
      <div className="content-section-content">
        {data?.cards?.map((cardData, cardIndex) => (
          <div className="content-card" key={`$${cardIndex}`}>
            {/* <p className="card-number">{cardIndex + 1}</p> */}
            <div className="content-card-image-wrapper">
              <img
                src={cardData?.cardImage?.asset?.url}
                alt="card-image"
                className="offer-icon"
              />
            </div>
            {classname === "accelerators-section" ? (
              <div className="content-wrapper">
                <div className="content-card-title">
                  <span className="card-number">{cardIndex + 1}</span>
                  <div className="main-card-title">
                    {cardData?.miscContent === "Design & Fabrication" && (
                      <p className="new-blue">Secret Menu</p>
                    )}
                    <PortableText
                      value={cardData?._rawTitle}
                      components={srelizerComponent}
                    />
                    {cardData?.miscContent === "Design & Fabrication" && (
                      <span className="extended-text">
                        {" "}
                        - Hardware/Robotics
                      </span>
                    )}
                  </div>
                </div>
                {cardData?._rawDescription && (
                  <div className="content-card-description">
                    <PortableText
                      value={cardData?._rawDescription}
                      components={srelizerComponent}
                    />
                  </div>
                )}
                <div className="content-card-cta-links">
                  <div className="new-buttons-wrapper">
                    <div
                      className={` ${
                        cardData?.cta?.cta_icon
                          ? "cta-with-icon"
                          : "new-button-container"
                      }`}
                    >
                      <Link to={cardData?.cta?.cta_link}>
                        <button className={cardData?.cta?.cta_style}>
                          {cardData?.cta?.cta_name}
                        </button>
                        {cardData?.cta?.cta_icon && (
                          <img
                            src={cardData?.cta?.cta_icon?.asset?.url}
                            alt="icon"
                            className="card-cta-icon"
                          />
                        )}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="content-card-title">
                  <PortableText
                    value={cardData?._rawTitle}
                    components={srelizerComponent}
                  />
                </div>
                <div className="content-card-description">
                  <PortableText
                    value={cardData?._rawDescription}
                    components={srelizerComponent}
                  />
                </div>
                <div className="content-card-cta-links">
                  <div className="new-buttons-wrapper">
                    <div
                      className={` ${
                        cardData?.cta?.cta_icon
                          ? "cta-with-icon"
                          : "new-button-container"
                      }`}
                    >
                      <Link to={cardData?.cta?.cta_link}>
                        <button className={cardData?.cta?.cta_style}>
                          {cardData?.cta?.cta_name}
                        </button>
                        {cardData?.cta?.cta_icon && (
                          <img
                            src={cardData?.cta?.cta_icon?.asset?.url}
                            alt="icon"
                            className="card-cta-icon"
                          />
                        )}
                      </Link>
                    </div>
                  </div>
                </div>
              </>
            )}
            {/* {cardData?.cta && (
              <div className="content-card-cta-links">
                <div className="new-buttons-wrapper">
                  <div
                    className={` ${
                      cardData?.cta?.cta_icon
                        ? "cta-with-icon"
                        : "new-button-container"
                    }`}
                  >
                    <Link to={cardData?.cta?.cta_link}>
                      <button className={cardData?.cta?.cta_style}>
                        {cardData?.cta?.cta_name}
                      </button>
                      {cardData?.cta?.cta_icon && (
                        <img
                          src={cardData?.cta?.cta_icon?.asset?.url}
                          alt="icon"
                          className="card-cta-icon"
                        />
                      )}
                    </Link>
                  </div>
                </div>
              </div>
            )} */}
          </div>
        ))}
      </div>
    </div>
  )
}

export default ContentSection
